// @flow

import styled from 'styled-components';
import React from 'react';
import { Text } from '../Text';

type Props = {
  id: string,
  width: ?number,
  height: ?number,
  onClick: (event: any) => boolean,
  format: string,
  webcamErrorText: string,
  webcamUnavailableText: string,
};

type State = {
  autoPlay: boolean,
  error: any,
};

const Hidden = styled.div`
  display: none;
`;

const Canvas = styled.canvas`
  width: 100%;
  height: 100%;
`;

export default class PhotoCapture extends React.Component<Props, State> {
  animationRef: requestAnimationFrame;

  constructor(props: Props) {
    super(props);
    this.state = {
      autoPlay: true,
      error: null,
    };
  }

  handleVideo = (stream) => {
    this.videoRef.src = window.URL.createObjectURL(stream);
    const ctx = this.canvasRef.getContext('2d');
    const drawVideo = (timestamp) => {
      if (this.videoRef)
        ctx.drawImage(
          this.videoRef,
          0,
          0,
          this.canvasRef.offsetWidth,
          this.canvasRef.offsetHeight
        );
      requestAnimationFrame(drawVideo);
    };
    this.animationRef = requestAnimationFrame(drawVideo);
  };

  handleError = (error) => {
    this.setState({
      error: error,
    });
  };

  componentDidMount() {
    if (navigator.mediaDevices) {
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then(this.handleVideo)
        .catch((error) => this.handleError(error));
    }
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.animationRef);
  }

  getScreenShot() {
    return this.canvasRef.toDataURL(this.props.format);
  }

  render() {
    if (this.state.error) return <Text>{this.props.webcamErrorText}</Text>;
    else if (navigator.mediaDevices)
      return (
        <span>
          <Hidden>
            <video
              ref={(video) => (this.videoRef = video)}
              autoPlay={this.state.autoPlay}
            />
          </Hidden>
          <Canvas
            ref={(canvas) => (this.canvasRef = canvas)}
            onClick={this.props.onClick}
          />
        </span>
      );
    else return <Text>{this.props.webcamUnavailableText}</Text>;
  }
}
